import { useEffect, useCallback, useState } from 'react';
import websocketManager from '../services/websocketManager';

export function useWebSocket(token, onMessage, jobId = null) {
  const [isConnected, setIsConnected] = useState(false);

  // Subscribe to connection status changes
  useEffect(() => {
    const checkConnection = () => {
      setIsConnected(websocketManager.getConnectionStatus());
    };

    const interval = setInterval(checkConnection, 1000);
    checkConnection(); // Initial check

    return () => clearInterval(interval);
  }, []);

  // Subscribe to messages
  useEffect(() => {
    if (!onMessage || jobId) return;

    const unsubscribe = websocketManager.subscribe(onMessage);
    return unsubscribe;
  }, [jobId, onMessage]);

  // Subscribe to specific job
  useEffect(() => {
    if (!jobId || !onMessage) return;

    const unsubscribe = websocketManager.subscribeToJob(jobId, onMessage);
    return unsubscribe;
  }, [jobId, onMessage]);

  // ✅ FIX: Only connect if we have a token and either message handler or job subscription
  useEffect(() => {
    if (token && (onMessage || jobId)) {
      websocketManager.connect(token);
    }
  }, [token, onMessage, jobId]);

  // ✅ FIX: Remove storage event listener - it causes excessive reconnections
  // The WebSocket manager will use the latest token from localStorage when needed
  // This prevents reconnection loops when api.js refreshes tokens
  // useEffect(() => {
  //   const handleStorageChange = (e) => {
  //     if (e.key === 'access_token' && e.newValue) {
  //       // Token was updated, reconnect WebSocket
  //       websocketManager.connect(e.newValue);
  //     }
  //   };
  //
  //   window.addEventListener('storage', handleStorageChange);
  //   return () => window.removeEventListener('storage', handleStorageChange);
  // }, []);

  const sendMessage = useCallback((message) => {
    websocketManager.sendMessage(message);
  }, []);

  const updateJobId = useCallback((newJobId) => {
    if (!newJobId || !onMessage) return;
    return websocketManager.subscribeToJob(newJobId, onMessage);
  }, [onMessage]);

  return {
    isConnected,
    error: null,
    sendMessage,
    updateJobId,
  };
}
